import { ApiReport, UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import saveStreamZIP from '../../../infra/helper/saveStreamZIP'

export default (requestid, type, part) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    let filename = requestid;
    if(type == 'detail' && part > 1) {
        filename += '_' + part;
    }

    let data = {
        'request-id':requestid,
        'type':type,
        'part':part
    }

    const Authorization = UserToken;
    const url = ApiReport + 'report-download';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
            'Content-Type':'application/json',
        },
        body : JSON.stringify(data)
    };

    const response = await doFetch(url,argument);
    if(response.ok){
        var responseText = await response.text();
        saveStreamZIP(`${filename}.zip`, responseText)
    }
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};
